// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { BooleanField, DateTimeField, FormType, RadioField, TextField } from "@hex-insights/forms";
import { UserFormValidation, UserFormValues } from "../../FormUtilities";
import { PermissionGroupSelectField } from "../PermissionGroup";
import { PersonSelectField } from "../Person";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the User model.
 */
type FieldProps<K extends keyof UserFormValues.Base = keyof UserFormValues.Base> = BaseFieldProps<
	Pick<UserFormValues.Base, K>
>;

/**
 * Generic props for fields of the User model that only appear in the detail form.
 */
type DetailFieldProps<K extends keyof UserFormValues.Detail = keyof UserFormValues.Detail> = BaseFieldProps<
	Pick<UserFormValues.Detail, K>
>;

/**
 * Field component for the `email` field of the User model.
 */
export function Email({ formState, instanceID, ...props }: FieldProps<"email"> & Partial<Models.FieldInstanceIDProps>) {
	Models.requireInstanceIDForUpdateForm(instanceID, formState.formType, "Email");
	const validateUnique = UserFormValidation.useUniqueEmailValidator(instanceID);

	return <TextField formState={formState} name="email" scheduledValidation={validateUnique} {...props} />;
}

/**
 * Field component for the `status` field of the User model.
 */
export function Status({ formState, ...props }: DetailFieldProps<"status">) {
	return (
		<RadioField
			formState={formState}
			name="status"
			options={UserFormValues.statusOptions}
			blankValue={null}
			optional={FormType.isCreate(formState.formType)}
			{...props}
		/>
	);
}

/**
 * Field component for the `passwordUpdatedAt` field of the User model.
 */
export function PasswordUpdatedAt({ formState, ...props }: DetailFieldProps<"passwordUpdatedAt">) {
	return (
		<DateTimeField
			formState={formState}
			name="passwordUpdatedAt"
			optional={FormType.isCreate(formState.formType)}
			precision="minute"
			{...props}
		/>
	);
}

/**
 * Field component for the `isCurrent` field of the User model.
 */
export function IsCurrent({ formState, ...props }: DetailFieldProps<"isCurrent">) {
	return <BooleanField formState={formState} name="isCurrent" {...props} />;
}

/**
 * Field component for the `timeZoneName` field of the User model.
 */
export function TimeZoneName({ formState, ...props }: FieldProps<"timeZoneName">) {
	return <TextField formState={formState} name="timeZoneName" optional {...props} />;
}

/**
 * Field component for the `externalNotificationFrequency` field of the User model.
 */
export function ExternalNotificationFrequency({
	formState,
	...props
}: DetailFieldProps<"externalNotificationFrequency">) {
	return (
		<RadioField
			formState={formState}
			name="externalNotificationFrequency"
			options={UserFormValues.externalNotificationFrequencyOptions}
			blankValue={null}
			optional={FormType.isCreate(formState.formType)}
			{...props}
		/>
	);
}

export namespace PermissionGroups {
	export type SelectProps = FieldProps<"permissionGroupIDs"> &
		Omit<PermissionGroupSelectField.MultiSelectProps<UserFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `permissionGroups` edge of the User model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <PermissionGroupSelectField.MultiSelect formState={formState} name="permissionGroupIDs" {...props} />;
	}
}

export namespace Person {
	export type SelectProps = FieldProps<"personID"> &
		Omit<PersonSelectField.SelectProps<UserFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `person` edge of the User model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <PersonSelectField.Select formState={formState} name="personID" optional {...props} />;
	}
}
